<template>
  <Admin style="background: white">
    <v-main class="wrapper">
      <v-container fluid>
        <v-card>
          <div class="table-container">
            <div class="pt-8 table-toolbar">
              <v-row class="px-3 pa-0 tw-gap-4" wrap align="center">
                <v-col cols="12" sm="6" md="3" class="pa-0">
                  <div class="tw-flex tw-flex-wrap tw-gap-2 tw-mb-5">
                    <v-btn
                      color="primary"
                      class="py-4 tw-text-sm tw-tracking-normal"
                      :disabled="true"
                      elevation="0"
                    >
                      <v-icon left>mdi-check</v-icon>
                      ยืนยันเอกสาร
                    </v-btn>
                    <v-btn
                      color="blue"
                      class="py-4 tw-text-sm tw-tracking-normal"
                      outlined
                      @click="triggerFileInput"
                      elevation="0"
                    >
                      <v-icon left>mdi-file-upload-outline</v-icon>
                      อัพโหลดเอกสาร
                    </v-btn>
                    <input
                      ref="fileInput"
                      type="file"
                      accept=".pdf"
                      multiple
                      style="display: none"
                      @change="handleFileUpload"
                    />
                    <v-btn
                      color="primary"
                      class="py-4 tw-text-sm tw-tracking-normal"
                      outlined
                      :disabled="true"
                      elevation="0"
                    >
                      <v-icon left>mdi-table-arrow-right</v-icon>
                      ส่งออกข้อมูล
                    </v-btn>
                  </div>
                </v-col>
                <v-spacer></v-spacer>
                <template>
                    <v-col cols="12" sm="6" md="2" class="pa-0 min-w-0">
                    <v-text-field
                      class="ma-0 pa-0 tw-text-sm"
                      label="ค้นหาเลขที่เอกสาร"
                      dense
                      append-icon="mdi-magnify"
                      v-model="searchDocID"
                      @input="debounceInput"
                      outlined
                      hide-details
                    />
                    <v-checkbox
                      v-model="aiSearchEnabled"
                      label="AI Search"
                      color="primary"
                      dense
                      class="mt-0"
                      hide-details
                      @change="handleAiSearchToggle"
                    ></v-checkbox>
                  </v-col>
                </template>
                <v-col cols="12" sm="6" md="2" class="pa-0">
                  <v-select
                    :menu-props="{ bottom: true, offsetY: true }"
                    v-model="searchStatus"
                    :items="statusOptions"
                    label="สถานะเอกสาร"
                    dense
                    @change="applyFiltersAndSort"
                    outlined
                  />
                </v-col>
                <v-col cols="12" sm="12" md="4" class="pa-0">
                  <date-range-search
                    outline
                    :initial-from-date="searchStartDate"
                    :initial-to-date="searchEndDate"
                    :on-reset="resetDateSearch"
                    :on-search="fetchByDateRange"
                  />
                </v-col>
              </v-row>
            </div>
            <table class="custom-table tw-text-sm">
              <thead>
                <tr>
                  <th class="tw-cursor-pointer" @click="sortTable('timestamp')">
                    วันที่สร้างไฟล์<br />(Created At)
                    <v-icon v-if="sortBy === 'timestamp'">
                      {{ sortDirection === 'asc' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                  </th>
                  <th class="tw-cursor-pointer" @click="sortTable('fileName')">
                    ชื่อไฟล์<br />(File Name)
                    <v-icon v-if="sortBy === 'fileName'">
                      {{ sortDirection === 'asc' ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                  </th>
                  <th>ประเภทไฟล์<br />(Type)</th>
                  <th>สถานะเอกสาร<br />(Status)</th>
                  <!-- <th>ID</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in displayedItems" :key="item.id || index">
                  <td>{{ formatDate(item.timestamp) }}</td>
                  <td>{{ item.fileName || item.name || '-' }}.{{ item.extension }}</td>
                  <td>{{ item.fileType || item.type || '-' }}</td>
                  <td>{{ item.status || '-' }}</td>
                  <!-- <td>{{ item.id }}</td> -->
                </tr>
              </tbody>
            </table>
            <div
              v-if="totalItems === 0 && !isLoadingDocs"
              class="tw-text-center tw-w-full tw-opacity-80 tw-py-40"
            >
              <h2>ไม่พบข้อมูลใน PurchaseInvoiceFiles</h2>
            </div>
            <v-progress-linear
              indeterminate
              color="green"
              :active="isLoadingDocs"
            ></v-progress-linear>
          </div>
        </v-card>
        <v-row justify="start" class="tw-my-4">
          <div class="tw-px-4">
            {{ itemsRangeText }}
          </div>
          <v-spacer />
          <v-pagination
            v-model="currentPage"
            :length="numPages"
            :total-visible="6"
            @input="paginate"
          ></v-pagination>
          <v-spacer />
        </v-row>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "@/components/admin/admin-main-template";
import fc from "@/firebaseConfig";
import moment from "moment";
import DateRangeSearch from "@/components/admin/documents/date-range-search.vue";

export default {
  name: "documents.accountspayable.upload",
  components: { Admin, DateRangeSearch },
  data() {
    return {
      // loading
      isLoadingDocs: true,
      // data
      files: [], // raw files
      displayedItems: [], // paginated/sorted
      totalItems: 0,
      companyId: "",
      filesToUpload: [],
      // paging
      currentPage: 1,
      itemsPerPage: Number.parseInt(localStorage.getItem("pageLimit")) || 10,
      // sorting
      sortBy: "timestamp",
      sortDirection: "desc",
      // filters
      searchDocID: "",
      searchStatus: "SHOW_ALL",
      searchStartDate: null,
      searchEndDate: null,
      statusOptions: [
        { text: "ทั้งหมด", value: "SHOW_ALL" },
        { text: "Pending", value: "PENDING_APPROVAL" },
        { text: "Posting", value: "POSTING" },
        { text: "Warning", value: "WARNING" },
        { text: "Error", value: "ERROR" },
        { text: "Success", value: "SUCCESS" },
      ],
      // misc
      unsubscribe: null,
    };
  },
  methods: {
    handleSearch() {
      this.currentPage = 1;
      this.applyFiltersAndSort();
    },
    resetDateSearch() {
      this.searchStartDate = null;
      this.searchEndDate = null;
      this.currentPage = 1;
      this.applyFiltersAndSort();
    },
    fetchByDateRange({ fromDate, toDate }) {
      this.searchStartDate = fromDate;
      this.searchEndDate = toDate;
      this.currentPage = 1;
      this.applyFiltersAndSort();
    },
    sortTable(field) {
      if (this.sortBy === field) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortBy = field;
        this.sortDirection = "asc";
      }
      this.applyFiltersAndSort();
    },
    paginate() {
      this.applyFiltersAndSort();
    },
    applyFiltersAndSort() {
      // filter
      let items = [...this.files];

      // text search (fileName / id)
      const q = (this.searchDocID || "").toLowerCase().trim();
      if (q) {
        items = items.filter((it) => {
          const name = `${it.fileName || it.name || ""}`.toLowerCase();
          const id = `${it.id || ""}`.toLowerCase();
          return name.includes(q) || id.includes(q);
        });
      }

      // status filter
      if (this.searchStatus && this.searchStatus !== "SHOW_ALL") {
        items = items.filter((it) => (it.status || "").toUpperCase() === this.searchStatus);
      }

      // date range filter (timestamp)
      if (this.searchStartDate) {
        const start = new Date(this.searchStartDate);
        start.setHours(0, 0, 0, 0);
        const end = this.searchEndDate ? new Date(this.searchEndDate) : new Date(this.searchStartDate);
        end.setHours(23, 59, 59, 999);

        items = items.filter((it) => {
          const ts = it.timestamp?.toDate ? it.timestamp.toDate() : new Date(it.timestamp);
          if (isNaN(ts?.getTime?.() ?? NaN)) return false;
          return ts >= start && ts <= end;
        });
      }

      // sort
      items.sort((a, b) => {
        const dir = this.sortDirection === "asc" ? 1 : -1;
        let av;
        let bv;
        if (this.sortBy === "timestamp") {
          av = a.timestamp?.toDate ? a.timestamp.toDate() : new Date(a.timestamp || 0);
          bv = b.timestamp?.toDate ? b.timestamp.toDate() : new Date(b.timestamp || 0);
          return (av - bv) * dir;
        }
        av = (a[this.sortBy] || "").toString().toLowerCase();
        bv = (b[this.sortBy] || "").toString().toLowerCase();
        if (av < bv) return -1 * dir;
        if (av > bv) return 1 * dir;
        return 0;
      });

      // paging
      this.totalItems = items.length;
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      this.displayedItems = items.slice(startIndex, endIndex);
      console.log("UploadDoc displayedItems:", this.displayedItems);
    },
    triggerFileInput() {
      if (this.$refs.fileInput) this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const files = Array.from(event.target.files || []);
      this.filesToUpload = files;
      if (files.length > 0) {
        this.uploadFiles();
      }
    },
    async uploadFiles() {
      try {
        if (!this.companyId) this.companyId = this.$route.params.companyId || "";
        if (!this.filesToUpload || this.filesToUpload.length === 0) return;
        // Reuse existing action from VAT Monthly page
        await this.$store.dispatch("companies/uploadUserPDFFile", {
          companyID: this.companyId,
          files: this.filesToUpload,
        });
      } catch (err) {
        console.error("Upload failed:", err);
      } finally {
        this.filesToUpload = [];
        if (this.$refs.fileInput) this.$refs.fileInput.value = "";
      }
    },
    formatDate(value) {
      if (!value) return "-";
      // Firestore Timestamp
      if (value && typeof value.toDate === "function") {
        return moment(value.toDate()).format("YYYY-MM-DD HH:mm");
      }
      // ISO string / millis
      const d = new Date(value);
      if (!isNaN(d.getTime())) {
        return moment(d).format("YYYY-MM-DD HH:mm");
      }
      return "-";
    },
    subscribeFiles() {
      const companyID = this.$route.params.companyId;
      if (!companyID) return;
      const ref = fc.db.collection(`Companies/${companyID}/PurchaseInvoiceFiles`);
      // Live updates
      this.unsubscribe = ref.onSnapshot(
        (snap) => {
          this.files = snap.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          this.isLoadingDocs = false;
          this.currentPage = 1;
          this.applyFiltersAndSort();
        },
        (err) => {
          console.error("Failed to fetch PurchaseInvoiceFiles:", err);
          this.files = [];
          this.isLoadingDocs = false;
          this.totalItems = 0;
          this.displayedItems = [];
          console.log("ddddddddddddddddddd", this.displayedItems);
        }
      );
    },
  },
  computed: {
    numPages() {
      return Math.max(1, Math.ceil(this.totalItems / this.itemsPerPage));
    },
    itemsRangeText() {
      if (this.totalItems === 0) return "0 - 0 จาก 0";
      const start = (this.currentPage - 1) * this.itemsPerPage + 1;
      const end = Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
      return `${start} - ${end} จาก ${this.totalItems}`;
    },
  },
  created() {
    this.companyId = this.$route.params.companyId || "";
    this.subscribeFiles();
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
  },
};
</script>

<style lang="scss" scoped>
/* copied styles to match VAT Monthly look-and-feel */
.table-container {
  width: 100%;
  overflow-x: auto;
  td,
  th {
    white-space: nowrap;
  }
}
.table-toolbar {
  padding: 1rem;
}
.custom-table {
  border-collapse: collapse;
  width: 100%;
  overflow: hidden;
}
.custom-table th {
  padding: 0 10px;
  text-align: left;
  white-space: nowrap;
  height: 60px;
  border-bottom: 1px solid rgb(182, 182, 182);
  font-weight: 400;
}
.custom-table td {
  padding: 0 10px;
  text-align: left;
  white-space: nowrap;
}
.custom-table tbody tr {
  border-bottom: 1px solid #e6e6e6;
  padding: 0 10px;
  height: 3rem;
}
.custom-table tbody tr:hover {
  background-color: #f2f2f27b;
  cursor: pointer;
}
.custom-table tbody tr:active {
  background-color: #cac8c87b;
  cursor: pointer;
}
</style>


